import _ from 'lodash';
import { SDLUtil } from '@/utils';

/**
 * param: response (Object)
 * return:
 * exception:
 * description: 엑셀 다운로드 후처리 (Excel download postprocessing)
 * since: 2024.06.28
 */
export const afterDownload = (response) => {
  const getFileName = contentDisposition => {
    const fileName = contentDisposition
      .split(';')
      .filter(ele => ele.indexOf('filename') > -1)
      .map(ele => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0] ? fileName[0] : null;
  };

  try {
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    let fileName = '';
    if (response.headers['content-disposition']) {
      fileName = getFileName(response.headers['content-disposition']);
    } else {
      // eslint-disable-next-line prefer-destructuring
      fileName = this.excelInfo.fileName;
    }

    fileName = decodeURI(fileName); // File name decoding (option of use according to project)

    if (window.navigator.msSaveOrOpenBlob) {
      // IE 10+
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // not IE
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.target = '_self';
      if (fileName) link.download = fileName;
      link.click();
    }
    SDLUtil.showLoadingBar(false);
    // return response.data;
  } catch (e) {
    SDLUtil.showLoadingBar(false);
    console.error(e);
  }
}


export default {
  afterDownload,
};



// WEBPACK FOOTER //
// ./src/service/excelCommService.js